<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>



                <van-cell title="场地平面图" :value="formData.changdi_pic.length+'/5'">
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.changdi_pic" :limit="5"
                                 :name="'changdi_pic'"></PicUploader>
                </div>
                <div class="operate-desc-left">上传场地平面照片</div>


                <van-cell  title="是否需要安装">
                    <template #right-icon>
                        <van-switch   v-model="formData.need_service"  active-color="#ffad19" :active-value="1" :inactive-value="2" size="24" />
                    </template>
                </van-cell>


                <van-field
                        v-model="formData.diynote"
                        rows="2"
                        type="textarea"
                        autosize
                        label="特殊情况说明"
                        input-align="right"
                        clearable
                        placeholder="请输入特殊情况说明"
                />

                <van-field
                        v-model="formData.name"
                        :rules="[{ required: true, message: '不能为空' }]"
                        label="收件人"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入收件人"
                />

                <van-field
                        v-model="formData.phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="手机号"
                        input-align="right"
                        clearable
                        placeholder="请输入手机号"
                />


                <van-field
                        readonly
                        clickable
                        name="area"
                        :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
                        input-align="right"
                        label="地区选择"
                        placeholder="点击选择省市区"
                        @click="showArea = true"
                />
                <van-popup v-model="showArea" position="bottom">
                    <van-area
                            :area-list="areaList"
                            :value="formData.area"
                            @confirm="onAreaConfirm"
                            @cancel="showArea = false"
                    />
                </van-popup>

                <van-field
                        v-model="formData.address"
                        :rules="[{ required: true, message: '请输入详细地址' }]"
                        error-message-align="right"
                        label="详细地址"
                        input-align="right"
                        clearable
                        placeholder="请输入详细地址"
                />


                <van-cell  title="是否需要发票">
                    <template #right-icon>
                        <van-switch  v-model="formData.need_fapiao"  active-color="#ffad19" :active-value="1" :inactive-value="2" size="24" />
                    </template>
                </van-cell>

                <van-field
                        v-if="formData.need_fapiao==1"
                        v-model="formData.fapiao_taitou"
                        :rules="[{ required: true, message: '发票抬头不能为空' }]"
                        label="发票抬头"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入发票抬头"
                />
                <van-field
                        v-if="formData.need_fapiao==1"
                        v-model="formData.fapiao_shuihao"
                        :rules="[{ required: true, message: '税号不能为空' }]"
                        label="税号"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入税号"
                />
                <div
                        v-if="formData.need_fapiao==1" class="operate-desc-left">如果您所在的单位没有纳税人识别号请填写“无”</div>

            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
        .use(Switch).use(Button);
    export default {
        name: 'ClubApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                    need_service:1,
                    need_fapiao:2,
                    areas:'',
                    name:'',
                    phone:'',
                    province:'',
                    qq:'',
                    city:'',
                    county:'',
                    changdi_pic: [],
                },
            }
        },
        filters: {},
        mounted() {
            document.title="开始建设"

            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
//            if(that.formData.id){
            this.fetch();
//            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;

                for (let field in that.formData) {
                    if (that.formData.changdi_pic.length == 0) {
                        Toast('请上传场地平面图');
                        return
                    }
                    if (!this.formData.area) {
                        Toast('请选择地区');
                        return
                    }
                }
                that.saveLoading = true;

                that.$api.post('/api/club/jiansheStep3Save', that.formData, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:"ClubJiansheList",
                        query:{
                            id:res.data.id
                        }
                    },'back')
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/club/jiansheStep3Detail', {
                    id:that.formData.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
//                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ClubJiansheStep3.vue?66f2bf0f